type PhotoType = 'EventPhoto' | 'WebsiteHeader' | 'PagePhoto' | 'CustomPhotoBlock' | 'CustomGalleryComponent' | 'Album' | 'AlbumPhoto' | 'WeddingPartyMember';

type PhotoChangeType = 'add' | 'change' | 'delete';

type PhotoChangedArgs = Readonly<{
  photoType: PhotoType;
  changeType: PhotoChangeType;
  oldUrl?: string;
  newUrl?: string;
  /** Use for batch operations (e.g. bulk album upload) where many URLs change at once. */
  oldUrls?: string[];
  newUrls?: string[];
  changedBy: string;
  eventId: string;
  surface: string;
  oldValue?: string;
  newValue?: string;
  /** Optional upload-pipeline context (e.g. PhotoUploadUseCase.area / subArea). */
  area?: string;
  subArea?: string;
}>;

export const PHOTO_CHANGED_ACTION = 'PhotoChanged';

export const photoChangedAction = (category: string) => (args: PhotoChangedArgs) => ({
  action: PHOTO_CHANGED_ACTION,
  category,
  extraInfo: {
    name: 'photoChanged' as const,
    ...args,
  },
});
